import React from 'react';
import PropTypes from 'prop-types';

import Modal from 'common/components/modals/Modal';

const AgeGateModal = ({
  isModalOpen,
  onRequestClose,
  headerComponent,
  bodyComponent,
  footerComponent,
}) => (
  <Modal
    shouldCloseOnOverlayClick={false}
    shouldCloseOnEsc={false}
    closable={false}
    isOpen={isModalOpen}
    onRequestClose={onRequestClose}
    bodyClassName={'age-gate__modal-body'}
    overlayClassName={'age-gate__modal-overlay'}
  >
    <div id="age-gate" className="Modal__body age-gate__modal">
      {headerComponent && headerComponent()}
      {bodyComponent && bodyComponent()}
    </div>
    {footerComponent && footerComponent()}
  </Modal>
);

AgeGateModal.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
};
export default AgeGateModal;
